/**
 * Under the current settings of the application and the way menus work (AdminDashboard),
 * there could be 3 different states:
 *  1. Number => takes a valid number associated with the pages its opening from dashboard
 *  2. undefined => clicking on this menu item wont trigger any action (stays on the same page)
 *  3. camelCase of the Page text => it opens the CommingSoon page !important
 */

export const menuItemToLink = {
  assets: undefined,
  resources: '20',
  accounts: '21',
  locations: '23',
  multiTenantBuildings: '27',
  people: undefined,
  users: '22',
  contacts: '24',
  services: '25',
  skillSets: '26',
  accessManagement: '03',
  operationalGroups: '033',
  userGroups: '035',
  featureGroups: '037',
  territoryGroups: '039',
  commercialZones: '0393',
  geoZones: '0395',
  approvals: '43',
  alerts: 'alerts',
  notifications: 'notifications',
  heatMaps: 'heatMaps',
  userActivity: '63',
  auditLog: '65',
  import: '73',
  export: '75',
  adaptersIntegrations: 'adaptersIntegrations',
  themes: '81',
  templates: '82',
  dashboards: '88',
  historicalData: '89',
  mapMarkers: '83',
  dataFieldManagement: '84',
  imageManagement: 'imageManagement',
  refrenceData: '85',
  tempDyn: '86',
  fieldmngr: '87'
}
